/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Injectable, inject } from '@angular/core';
import { LocalStorageService } from '@df/browser/storage/local-storage.service';
import { DfEventService } from '@df/core/service/df-event';
import { ucfirst } from '@df/util/fn/ucfirst.fn';
import { Nexus } from '@tomandco/nexus-api-types';
import isEmpty from 'lodash-es/isEmpty';
import pickBy from 'lodash-es/pickBy';
import { IRequestOptions, RequestService } from '../request/request.service';
const storageId = 'nexus-api-token';

declare module '@df/core/service/df-event' {
    interface IEventType {
        // basket
        nexusBasketAdd: DfEventConfig<'nexusBasketAdd', Nexus.Api.Basket.Add.Request, Nexus.Api.Basket.Add.Response>;
        nexusBasketChangeRequest: DfEventConfig<
            'nexusBasketChangeRequest',
            Nexus.Api.Basket.ChangeRequest.Request,
            Nexus.Api.Basket.ChangeRequest.Response
        >;
        nexusBasketQty: DfEventConfig<'nexusBasketQty', Nexus.Api.Basket.Qty.Request, Nexus.Api.Basket.Qty.Response>;
        nexusBasketRemove: DfEventConfig<'nexusBasketRemove', Nexus.Api.Basket.Remove.Request, Nexus.Api.Basket.Remove.Response>;
        nexusBasketFlush: DfEventConfig<'nexusBasketFlush', Nexus.Api.Basket.Flush.Request, Nexus.Api.Basket.Flush.Response>;
        // catalog
        nexusCatalogBundleGet: DfEventConfig<
            'nexusCatalogBundleGet',
            Nexus.Api.Catalog.Bundle.Get.Request,
            Nexus.Api.Catalog.Bundle.Response
        >;
        nexusCatalogBundlePost: DfEventConfig<
            'nexusCatalogBundlePost',
            Nexus.Api.Catalog.Bundle.Post.Request,
            Nexus.Api.Catalog.Bundle.Response
        >;
        nexusCatalogFindAlternate: DfEventConfig<
            'nexusCatalogFindAlternate',
            Nexus.Api.Catalog.FindAlternate.Request,
            Nexus.Api.Catalog.FindAlternate.Response
        >;
        nexusCatalogMeta: DfEventConfig<'nexusCatalogMeta', Nexus.Api.Catalog.Meta.Request, Nexus.Api.Catalog.Meta.Response>;
        // checkout
        nexusCheckoutLoad: DfEventConfig<'nexusCheckoutLoad', Nexus.Api.Checkout.Load.Request, Nexus.Api.Checkout.Load.Response>;
        nexusCheckoutLogin: DfEventConfig<'nexusCheckoutLogin', Nexus.Api.Checkout.Login.Request, Nexus.Api.Checkout.Login.Response>;
        nexusCheckoutLogout: DfEventConfig<'nexusCheckoutLogout', Nexus.Api.Checkout.Logout.Request, Nexus.Api.Checkout.Logout.Response>;
        nexusCheckoutSaveBillingAddress: DfEventConfig<
            'nexusCheckoutSaveBillingAddress',
            Nexus.Api.Checkout.SaveBillingAddress.Request,
            Nexus.Api.Checkout.SaveBillingAddress.Response
        >;
        nexusCheckoutSaveCustom: DfEventConfig<
            'nexusCheckoutSaveCustom',
            Nexus.Api.Checkout.SaveCustom.Request,
            Nexus.Api.Checkout.SaveCustom.Response
        >;
        nexusCheckoutSaveEmail: DfEventConfig<
            'nexusCheckoutSaveEmail',
            Nexus.Api.Checkout.SaveEmail.Request,
            Nexus.Api.Checkout.SaveEmail.Response
        >;
        nexusCheckoutSavePayment: DfEventConfig<
            'nexusCheckoutSavePayment',
            Nexus.Api.Checkout.SavePayment.Request,
            Nexus.Api.Checkout.SavePayment.Response
        >;
        nexusCheckoutSaveShippingAddress: DfEventConfig<
            'nexusCheckoutSaveShippingAddress',
            Nexus.Api.Checkout.SaveShippingAddress.Request,
            Nexus.Api.Checkout.SaveShippingAddress.Response
        >;
        nexusCheckoutSaveShippingMethod: DfEventConfig<
            'nexusCheckoutSaveShippingMethod',
            Nexus.Api.Checkout.SaveShippingMethod.Request,
            Nexus.Api.Checkout.SaveShippingMethod.Response
        >;
        nexusCheckoutSubmit: DfEventConfig<'nexusCheckoutSubmit', Nexus.Api.Checkout.Submit.Request, Nexus.Api.Checkout.Submit.Response>;
        nexusCheckoutSuccess: DfEventConfig<
            'nexusCheckoutSuccess',
            Nexus.Api.Checkout.Success.Request,
            Nexus.Api.Checkout.Success.Response
        >;
        nexusCheckoutPaymentCapture: DfEventConfig<
            'nexusCheckoutPaymentCapture',
            Nexus.Api.Checkout.PaymentCapture.Request,
            Nexus.Api.Checkout.PaymentCapture.Response
        >;
        nexusCheckoutPaymentCancel: DfEventConfig<
            'nexusCheckoutPaymentCancel',
            Nexus.Api.Checkout.PaymentCancel.Request,
            Nexus.Api.Checkout.PaymentCancel.Response
        >;
        // coupon
        nexusCouponAdd: DfEventConfig<'nexusCouponAdd', Nexus.Api.Coupon.Add.Request, Nexus.Api.Coupon.Add.Response>;
        nexusCouponRemove: DfEventConfig<'nexusCouponRemove', Nexus.Api.Coupon.Remove.Request, Nexus.Api.Coupon.Remove.Response>;
        // general
        nexusGeneralAppData: DfEventConfig<'nexusGeneralAppData', Nexus.Api.General.AppData.Request, Nexus.Api.General.AppData.Response>;
        nexusGeneralCountries: DfEventConfig<
            'nexusGeneralCountries',
            Nexus.Api.General.Countries.Request,
            Nexus.Api.General.Countries.Response
        >;
        // customer
        nexusCustomerData: DfEventConfig<'nexusCustomerData', Nexus.Api.Customer.Data.Request, Nexus.Api.Customer.Data.Response>;
        nexusCustomerExists: DfEventConfig<'nexusCustomerExists', Nexus.Api.Customer.Exists.Request, Nexus.Api.Customer.Exists.Response>;
        nexusCustomerLogin: DfEventConfig<'nexusCustomerLogin', Nexus.Api.Customer.Login.Request, Nexus.Api.Customer.Login.Response>;
        nexusCustomerLogout: DfEventConfig<'nexusCustomerLogout', Nexus.Api.Customer.Logout.Request, Nexus.Api.Customer.Logout.Response>;
        nexusCustomerSave: DfEventConfig<'nexusCustomerSave', Nexus.Api.Customer.Save.Request, Nexus.Api.Customer.Save.Response>;
        nexusCustomerSaveAddress: DfEventConfig<
            'nexusCustomerSaveAddress',
            Nexus.Api.Customer.SaveAddress.Request,
            Nexus.Api.Customer.SaveAddress.Response
        >;
        nexusCustomerRemoveAddress: DfEventConfig<
            'nexusCustomerRemoveAddress',
            Nexus.Api.Customer.RemoveAddress.Request,
            Nexus.Api.Customer.RemoveAddress.Response
        >;
        nexusCustomerOrders: DfEventConfig<'nexusCustomerOrders', Nexus.Api.Customer.Orders.Request, Nexus.Api.Customer.Orders.Response>;
        nexusCustomerRegister: DfEventConfig<
            'nexusCustomerRegister',
            Nexus.Api.Customer.Register.Request,
            Nexus.Api.Customer.Register.Response
        >;
        nexusCustomerRequestPasswordReset: DfEventConfig<
            'nexusCustomerRequestPasswordReset',
            Nexus.Api.Customer.RequestPasswordReset.Request,
            Nexus.Api.Customer.RequestPasswordReset.Response
        >;
        nexusCustomerApplyPasswordReset: DfEventConfig<
            'nexusCustomerApplyPasswordReset',
            Nexus.Api.Customer.ApplyPasswordReset.Request,
            Nexus.Api.Customer.ApplyPasswordReset.Response
        >;
        nexusCustomerRemoveSavedCard: DfEventConfig<
            'nexusCustomerRemoveSavedCard',
            Nexus.Api.Customer.RemoveSavedCard.Request,
            Nexus.Api.Customer.RemoveSavedCard.Response
        >;
        // indexer
        nexusIndexerReindex: DfEventConfig<'nexusIndexerReindex', Nexus.Api.Indexer.Reindex.Request, Nexus.Api.Indexer.Reindex.Response>;
        // newsletter
        nexusNewsletterSubscribe: DfEventConfig<
            'nexusNewsletterSubscribe',
            Nexus.Api.Newsletter.Subscribe.Request,
            Nexus.Api.Newsletter.Subscribe.Response
        >;
        nexusNewsletterUnsubscribe: DfEventConfig<
            'nexusNewsletterUnsubscribe',
            Nexus.Api.Newsletter.Unsubscribe.Request,
            Nexus.Api.Newsletter.Unsubscribe.Response
        >;
        nexusNewsletterUnsubscribeByAccount: DfEventConfig<
            'nexusNewsletterUnsubscribeByAccount',
            Nexus.Api.Newsletter.UnsubscribeByAccount.Request,
            Nexus.Api.Newsletter.UnsubscribeByAccount.Response
        >;
        // translate
        nexusTranslateMissing: DfEventConfig<
            'nexusTranslateMissing',
            Nexus.Api.Translate.Missing.Request,
            Nexus.Api.Translate.Missing.Response
        >;
        // wishlist
        nexusWishlistAdd: DfEventConfig<'nexusWishlistAdd', Nexus.Api.Wishlist.Add.Request, Nexus.Api.Wishlist.Add.Response>;
        nexusWishlistRemove: DfEventConfig<'nexusWishlistRemove', Nexus.Api.Wishlist.Remove.Request, Nexus.Api.Wishlist.Remove.Response>;
        nexusWishlistFlush: DfEventConfig<'nexusWishlistFlush', Nexus.Api.Wishlist.Flush.Request, Nexus.Api.Wishlist.Flush.Response>;
        nexusWishlistMoveFromBasket: DfEventConfig<
            'nexusWishlistMoveFromBasket',
            Nexus.Api.Wishlist.MoveFromBasket.Request,
            Nexus.Api.Wishlist.MoveFromBasket.Response
        >;
        nexusWishlistShare: DfEventConfig<'nexusWishlistShare', Nexus.Api.Wishlist.Share.Request, Nexus.Api.Wishlist.Share.Response>;
    }
}

@Injectable({
    providedIn: 'root'
})
export class NexusApiService {
    /**
     * Basket area
     */
    readonly basket = {
        /**
         * Add to basket
         */
        add: (data: Nexus.Api.Basket.Add.Request, options?: IRequestOptions) =>
            this.dfEvent.dispatch<Nexus.Api.Basket.Add.Response>({
                id: 'nexusBasketAdd',
                data,
                action: data => this.sendXHR<Nexus.Api.Basket.Add.Response>(Nexus.Api.Basket.Add.path, data, options)
            }),

        /**
         * Change item data
         */
        changeRequest: (data: Nexus.Api.Basket.ChangeRequest.Request, options?: IRequestOptions) =>
            this.dfEvent.dispatch<Nexus.Api.Basket.ChangeRequest.Response>({
                id: 'nexusBasketChangeRequest',
                data,
                action: data => this.sendXHR<Nexus.Api.Basket.ChangeRequest.Response>(Nexus.Api.Basket.ChangeRequest.path, data, options)
            }),

        /**
         * Change item qty
         */
        qty: (data: Nexus.Api.Basket.Qty.Request, options?: IRequestOptions) =>
            this.dfEvent.dispatch<Nexus.Api.Basket.Qty.Response>({
                id: 'nexusBasketQty',
                data,
                action: data => this.sendXHR<Nexus.Api.Basket.Qty.Response>(Nexus.Api.Basket.Qty.path, data, options)
            }),

        /**
         * Remove item from basket
         */
        remove: (data: Nexus.Api.Basket.Remove.Request, options?: IRequestOptions) =>
            this.dfEvent.dispatch<Nexus.Api.Basket.Remove.Response>({
                id: 'nexusBasketRemove',
                data,
                action: data => this.sendXHR<Nexus.Api.Basket.Remove.Response>(Nexus.Api.Basket.Remove.path, data, options)
            }),

        /**
         * Flush basket
         */
        flush: (data: Nexus.Api.Basket.Flush.Request, options?: IRequestOptions) =>
            this.dfEvent.dispatch<Nexus.Api.Basket.Flush.Response>({
                id: 'nexusBasketFlush',
                data,
                action: data => this.sendXHR<Nexus.Api.Basket.Flush.Response>(Nexus.Api.Basket.Flush.path, data, options)
            })
    };

    /**
     * Catalog data
     */
    readonly catalog = {
        /**
         * Bundle get request
         */
        bundleGet: (data: Nexus.Api.Catalog.Bundle.Get.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Catalog.Bundle.Response>({
                id: 'nexusCatalogBundleGet',
                data,
                action: data =>
                    this.sendXHR<Nexus.Api.Catalog.Bundle.Response>(Nexus.Api.Catalog.Bundle.path, data, {
                        api: 'node',
                        method: 'GET'
                    })
            }),
        /**
         * Bundle post request
         */
        bundlePost: (data: Nexus.Api.Catalog.Bundle.Post.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Catalog.Bundle.Response>({
                id: 'nexusCatalogBundlePost',
                data,
                action: data => this.sendXHR<Nexus.Api.Catalog.Bundle.Response>(Nexus.Api.Catalog.Bundle.path, data, { api: 'node' })
            }),

        /**
         * Find alternate
         */
        findAlternate: (data: Nexus.Api.Catalog.FindAlternate.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Catalog.FindAlternate.Response>({
                id: 'nexusCatalogFindAlternate',
                data,
                action: data =>
                    this.sendXHR<Nexus.Api.Catalog.FindAlternate.Response>(
                        Nexus.Api.Catalog.FindAlternate.path,
                        pickBy(
                            {
                                type: data.type,
                                id: data.id,
                                storesIds: JSON.stringify(data.storesIds),
                                filter: data.filter ? JSON.stringify(data.filter) : undefined
                            },
                            Boolean
                        ),
                        {
                            api: 'node',
                            method: 'GET'
                        }
                    )
            }),

        meta: (data: Nexus.Api.Catalog.Meta.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Catalog.Meta.Response>({
                id: 'nexusCatalogMeta',
                data,
                action: data =>
                    this.sendXHR<Nexus.Api.Catalog.Meta.Response>(Nexus.Api.Catalog.Meta.path, data, {
                        api: 'node'
                    })
            })
    };

    protected checkoutEndpoints = {
        load: Nexus.Api.Checkout.Load.path,
        login: Nexus.Api.Checkout.Login.path,
        logout: Nexus.Api.Checkout.Logout.path,
        saveBillingAddress: Nexus.Api.Checkout.SaveBillingAddress.path,
        saveCustom: Nexus.Api.Checkout.SaveCustom.path,
        saveEmail: Nexus.Api.Checkout.SaveEmail.path,
        savePayment: Nexus.Api.Checkout.SavePayment.path,
        saveShippingAddress: Nexus.Api.Checkout.SaveShippingAddress.path,
        saveShippingMethod: Nexus.Api.Checkout.SaveShippingMethod.path,
        submit: Nexus.Api.Checkout.Submit.path,
        success: Nexus.Api.Checkout.Success.path,
        paymentCapture: Nexus.Api.Checkout.PaymentCapture.path,
        paymentCancel: Nexus.Api.Checkout.PaymentCancel.path
    };

    readonly checkout = {
        /**
         * Load checkout data
         */
        load: (data: Nexus.Api.Checkout.Load.Request = {}) =>
            this.dfEvent.dispatch<Nexus.Api.Checkout.Load.Response>({
                id: 'nexusCheckoutLoad',
                data,
                action: data => this.sendXHR<Nexus.Api.Checkout.Load.Response>(this.checkoutEndpoints.load, data)
            }),

        /**
         * Login customer
         */
        login: (data: Nexus.Api.Checkout.Login.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Checkout.Login.Response>({
                id: 'nexusCheckoutLogin',
                data,
                action: data => this.sendXHR<Nexus.Api.Checkout.Login.Response>(this.checkoutEndpoints.login, data)
            }),

        /**
         * Logout customer
         */
        logout: (data: Nexus.Api.Checkout.Logout.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Checkout.Logout.Response>({
                id: 'nexusCheckoutLogout',
                data,
                action: data => this.sendXHR<Nexus.Api.Checkout.Logout.Response>(this.checkoutEndpoints.logout, data)
            }),
        /**
         * Save billing address
         */
        saveBillingAddress: (data: Nexus.Api.Checkout.SaveBillingAddress.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Checkout.SaveBillingAddress.Response>({
                id: 'nexusCheckoutSaveBillingAddress',
                data,
                action: data =>
                    this.sendXHR<Nexus.Api.Checkout.SaveBillingAddress.Response>(this.checkoutEndpoints.saveBillingAddress, data)
            }),
        /**
         * Save custom data
         */
        saveCustom: (data: Nexus.Api.Checkout.SaveCustom.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Checkout.SaveCustom.Response>({
                id: 'nexusCheckoutSaveCustom',
                data,
                action: data => this.sendXHR<Nexus.Api.Checkout.SaveCustom.Response>(this.checkoutEndpoints.saveCustom, data)
            }),
        /**
         * Save email
         */
        saveEmail: (data: Nexus.Api.Checkout.SaveEmail.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Checkout.SaveEmail.Response>({
                id: 'nexusCheckoutSaveEmail',
                data,
                action: data => this.sendXHR<Nexus.Api.Checkout.SaveEmail.Response>(this.checkoutEndpoints.saveEmail, data)
            }),
        /**
         * Save payment
         */
        savePayment: (data: Nexus.Api.Checkout.SavePayment.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Checkout.SavePayment.Response>({
                id: 'nexusCheckoutSavePayment',
                data,
                action: data => this.sendXHR<Nexus.Api.Checkout.SavePayment.Response>(this.checkoutEndpoints.savePayment, data)
            }),
        /**
         * Save shipping address
         */
        saveShippingAddress: (data: Nexus.Api.Checkout.SaveShippingAddress.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Checkout.SaveShippingAddress.Response>({
                id: 'nexusCheckoutSaveShippingAddress',
                data,
                action: data =>
                    this.sendXHR<Nexus.Api.Checkout.SaveShippingAddress.Response>(this.checkoutEndpoints.saveShippingAddress, data)
            }),
        /**
         * Save shipping method
         */
        saveShippingMethod: (data: Nexus.Api.Checkout.SaveShippingMethod.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Checkout.SaveShippingMethod.Response>({
                id: 'nexusCheckoutSaveShippingMethod',
                data,
                action: data =>
                    this.sendXHR<Nexus.Api.Checkout.SaveShippingMethod.Response>(this.checkoutEndpoints.saveShippingMethod, data)
            }),
        /**
         * Submit
         */
        submit: (data: Nexus.Api.Checkout.Submit.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Checkout.Submit.Response>({
                id: 'nexusCheckoutSubmit',
                data,
                action: data => this.sendXHR<Nexus.Api.Checkout.Submit.Response>(this.checkoutEndpoints.submit, data)
            }),
        /**
         * Load success data
         */
        success: (data: Nexus.Api.Checkout.Success.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Checkout.Success.Response>({
                id: 'nexusCheckoutSuccess',
                data,
                action: async data => {
                    const result = await this.sendXHR<Nexus.Api.Checkout.Success.Response>(this.checkoutEndpoints.success, data);
                    if (isEmpty(result?.success)) {
                        throw new Error('No order data found');
                    }
                    return result;
                }
            }),

        paymentCapture: (data: Nexus.Api.Checkout.PaymentCapture.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Checkout.PaymentCapture.Response>({
                id: 'nexusCheckoutPaymentCapture',
                data,
                action: data => this.sendXHR<Nexus.Api.Checkout.PaymentCapture.Response>(this.checkoutEndpoints.paymentCapture, data)
            }),

        paymentCancel: (data: Nexus.Api.Checkout.PaymentCancel.Request) =>
            this.dfEvent.dispatch<Nexus.Api.Checkout.PaymentCancel.Response>({
                id: 'nexusCheckoutPaymentCancel',
                data,
                action: data => this.sendXHR<Nexus.Api.Checkout.PaymentCancel.Response>(this.checkoutEndpoints.paymentCancel, data)
            })
    };

    readonly coupon = {
        /**
         * Add coupon
         */
        add: (data: Nexus.Api.Coupon.Add.Request): Promise<Nexus.Api.Coupon.Add.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Coupon.Add.Response>({
                id: 'nexusCouponAdd',
                data,
                action: data => this.sendXHR<Nexus.Api.Coupon.Add.Response>(Nexus.Api.Coupon.Add.path, data)
            }),

        /**
         * Remove coupon
         */
        remove: (data: Nexus.Api.Coupon.Remove.Request): Promise<Nexus.Api.Coupon.Remove.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Coupon.Remove.Response>({
                id: 'nexusCouponRemove',
                data,
                action: data => this.sendXHR<Nexus.Api.Coupon.Remove.Response>(Nexus.Api.Coupon.Remove.path, data)
            })
    };

    readonly general = {
        /**
         * Load app data
         */
        appData: (data: Nexus.Api.General.AppData.Request): Promise<Nexus.Api.General.AppData.Response> =>
            this.dfEvent.dispatch<Nexus.Api.General.AppData.Response>({
                id: 'nexusGeneralAppData',
                data,
                action: data => this.sendXHR<Nexus.Api.General.AppData.Response>(Nexus.Api.General.AppData.path, {}, { method: 'GET' })
            }),

        /**
         * Load countries list
         */
        countries: (data: Nexus.Api.General.Countries.Request): Promise<Nexus.Api.General.Countries.Response> =>
            this.dfEvent.dispatch<Nexus.Api.General.Countries.Response>({
                id: 'nexusGeneralCountries',
                data,
                action: data => this.sendXHR<Nexus.Api.General.Countries.Response>(Nexus.Api.General.Countries.path, {}, { method: 'GET' })
            })
    };

    readonly customer = {
        /**
         * Load customer data
         */
        data: (): Promise<Nexus.Api.Customer.Data.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Customer.Data.Response>({
                id: 'nexusCustomerData',
                data: {},
                action: data => this.sendXHR<Nexus.Api.Customer.Data.Response>(Nexus.Api.Customer.Data.path, {})
            }),

        /**
         * Exists
         */
        exists: (data: Nexus.Api.Customer.Exists.Request): Promise<Nexus.Api.Customer.Exists.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Customer.Exists.Response>({
                id: 'nexusCustomerExists',
                data,
                action: data => this.sendXHR<Nexus.Api.Customer.Exists.Response>(Nexus.Api.Customer.Exists.path, data)
            }),

        /**
         * Login
         */
        login: (data: Nexus.Api.Customer.Login.Request): Promise<Nexus.Api.Customer.Login.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Customer.Login.Response>({
                id: 'nexusCustomerLogin',
                data,
                action: data => this.sendXHR<Nexus.Api.Customer.Login.Response>(Nexus.Api.Customer.Login.path, data)
            }),

        /**
         * Logout
         */
        logout: (data: Nexus.Api.Customer.Logout.Request): Promise<Nexus.Api.Customer.Logout.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Customer.Logout.Response>({
                id: 'nexusCustomerLogout',
                data,
                action: data => this.sendXHR<Nexus.Api.Customer.Logout.Response>(Nexus.Api.Customer.Logout.path, data)
            }),

        /**
         * Save customer data
         */
        save: (data: Nexus.Api.Customer.Save.Request): Promise<Nexus.Api.Customer.Save.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Customer.Save.Response>({
                id: 'nexusCustomerSave',
                data,
                action: data => this.sendXHR<Nexus.Api.Customer.Save.Response>(Nexus.Api.Customer.Save.path, data)
            }),

        /**
         * Save address data
         */
        saveAddress: (data: Nexus.Api.Customer.SaveAddress.Request): Promise<Nexus.Api.Customer.SaveAddress.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Customer.SaveAddress.Response>({
                id: 'nexusCustomerSaveAddress',
                data,
                action: data => this.sendXHR<Nexus.Api.Customer.SaveAddress.Response>(Nexus.Api.Customer.SaveAddress.path, data)
            }),

        /**
         * Remove address
         */
        removeAddress: (data: Nexus.Api.Customer.RemoveAddress.Request): Promise<Nexus.Api.Customer.RemoveAddress.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Customer.RemoveAddress.Response>({
                id: 'nexusCustomerRemoveAddress',
                data,
                action: data => this.sendXHR<Nexus.Api.Customer.RemoveAddress.Response>(Nexus.Api.Customer.RemoveAddress.path, data)
            }),

        /**
         * Orders
         */
        orders: (data: Nexus.Api.Customer.Orders.Request): Promise<Nexus.Api.Customer.Orders.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Customer.Orders.Response>({
                id: 'nexusCustomerOrders',
                data,
                action: data => this.sendXHR<Nexus.Api.Customer.Orders.Response>(Nexus.Api.Customer.Orders.path, data)
            }),

        /**
         * Register
         */
        register: (data: Nexus.Api.Customer.Register.Request): Promise<Nexus.Api.Customer.Register.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Customer.Register.Response>({
                id: 'nexusCustomerRegister',
                data,
                action: data => this.sendXHR<Nexus.Api.Customer.Register.Response>(Nexus.Api.Customer.Register.path, data)
            }),

        /**
         * Reset password request
         */
        requestPasswordReset: (
            data: Nexus.Api.Customer.RequestPasswordReset.Request
        ): Promise<Nexus.Api.Customer.RequestPasswordReset.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Customer.RequestPasswordReset.Response>({
                id: 'nexusCustomerRequestPasswordReset',
                data,
                action: data =>
                    this.sendXHR<Nexus.Api.Customer.RequestPasswordReset.Response>(Nexus.Api.Customer.RequestPasswordReset.path, data)
            }),

        /**
         * Reset password apply
         */
        applyPasswordReset: (
            data: Nexus.Api.Customer.ApplyPasswordReset.Request
        ): Promise<Nexus.Api.Customer.ApplyPasswordReset.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Customer.ApplyPasswordReset.Response>({
                id: 'nexusCustomerApplyPasswordReset',
                data,
                action: data =>
                    this.sendXHR<Nexus.Api.Customer.ApplyPasswordReset.Response>(Nexus.Api.Customer.ApplyPasswordReset.path, data)
            }),

        /**
         * Update
         */
        removeSavedCard: (data: Nexus.Api.Customer.RemoveSavedCard.Request): Promise<Nexus.Api.Customer.RemoveSavedCard.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Customer.RemoveSavedCard.Response>({
                id: 'nexusCustomerRemoveSavedCard',
                data,
                action: data => this.sendXHR<Nexus.Api.Customer.RemoveSavedCard.Response>(Nexus.Api.Customer.RemoveSavedCard.path, data)
            })
    };

    readonly indexer = {
        /**
         * Reindex
         */
        reindex: (data: Nexus.Api.Indexer.Reindex.Request): Promise<Nexus.Api.Indexer.Reindex.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Indexer.Reindex.Response>({
                id: 'nexusIndexerReindex',
                data,
                action: data => this.sendXHR<Nexus.Api.Indexer.Reindex.Response>(Nexus.Api.Indexer.Reindex.path, data)
            })
    };

    readonly newsletter = {
        /**
         * Subscribe
         */
        subscribe: (data: Nexus.Api.Newsletter.Subscribe.Request): Promise<Nexus.Api.Newsletter.Subscribe.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Newsletter.Subscribe.Response>({
                id: 'nexusNewsletterSubscribe',
                data,
                action: data => this.sendXHR<Nexus.Api.Newsletter.Subscribe.Response>(Nexus.Api.Newsletter.Subscribe.path, data)
            }),

        /**
         * Unsubscribe
         */
        unsubscribe: (data: Nexus.Api.Newsletter.Unsubscribe.Request): Promise<Nexus.Api.Newsletter.Unsubscribe.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Newsletter.Unsubscribe.Response>({
                id: 'nexusNewsletterUnsubscribe',
                data,
                action: data => this.sendXHR<Nexus.Api.Newsletter.Unsubscribe.Response>(Nexus.Api.Newsletter.Unsubscribe.path, data)
            }),

        /**
         * Unsubscribe by account
         */
        unsubscribeByAccount: (
            data: Nexus.Api.Newsletter.UnsubscribeByAccount.Request
        ): Promise<Nexus.Api.Newsletter.UnsubscribeByAccount.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Newsletter.UnsubscribeByAccount.Response>({
                id: 'nexusNewsletterUnsubscribeByAccount',
                data,
                action: data =>
                    this.sendXHR<Nexus.Api.Newsletter.UnsubscribeByAccount.Response>(Nexus.Api.Newsletter.UnsubscribeByAccount.path, data)
            })
    };

    readonly translate = {
        /**
         * Missing
         */
        missing: (data: Nexus.Api.Translate.Missing.Request): Promise<Nexus.Api.Translate.Missing.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Translate.Missing.Response>({
                id: 'nexusTranslateMissing',
                data,
                action: data => this.sendXHR<Nexus.Api.Translate.Missing.Response>(Nexus.Api.Translate.Missing.path, data)
            })
    };

    readonly wishlist = {
        /**
         * Add
         */
        add: (data: Nexus.Api.Wishlist.Add.Request): Promise<Nexus.Api.Wishlist.Add.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Wishlist.Add.Response>({
                id: 'nexusWishlistAdd',
                data,
                action: data => this.sendXHR<Nexus.Api.Wishlist.Add.Response>(Nexus.Api.Wishlist.Add.path, data)
            }),

        /**
         * Remove
         */
        remove: (data: Nexus.Api.Wishlist.Remove.Request): Promise<Nexus.Api.Wishlist.Remove.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Wishlist.Remove.Response>({
                id: 'nexusWishlistRemove',
                data,
                action: data => this.sendXHR<Nexus.Api.Wishlist.Remove.Response>(Nexus.Api.Wishlist.Remove.path, data)
            }),

        /**
         * Flush
         */
        flush: (data: Nexus.Api.Wishlist.Flush.Request): Promise<Nexus.Api.Wishlist.Flush.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Wishlist.Flush.Response>({
                id: 'nexusWishlistFlush',
                data,
                action: data => this.sendXHR<Nexus.Api.Wishlist.Flush.Response>(Nexus.Api.Wishlist.Flush.path, data)
            }),

        /**
         * Move from basket
         */
        moveFromBasket: (data: Nexus.Api.Wishlist.MoveFromBasket.Request): Promise<Nexus.Api.Wishlist.MoveFromBasket.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Wishlist.MoveFromBasket.Response>({
                id: 'nexusWishlistMoveFromBasket',
                data,
                action: data => this.sendXHR<Nexus.Api.Wishlist.MoveFromBasket.Response>(Nexus.Api.Wishlist.MoveFromBasket.path, data)
            }),

        /**
         * Share
         */
        share: (data: Nexus.Api.Wishlist.Share.Request): Promise<Nexus.Api.Wishlist.Share.Response> =>
            this.dfEvent.dispatch<Nexus.Api.Wishlist.Share.Response>({
                id: 'nexusWishlistShare',
                data,
                action: data => this.sendXHR<Nexus.Api.Wishlist.Share.Response>(Nexus.Api.Wishlist.Share.path, data)
            })
    };

    /**
     * Nexus token
     */
    private token?: string;
    private localStorageService = inject(LocalStorageService);
    private requestService = inject(RequestService);
    private dfEvent = inject(DfEventService);

    constructor() {
        this.token = this.localStorageService.get(storageId);
    }

    protected async sendXHR<TResponse>(path: string, data: any, options?: IRequestOptions): Promise<TResponse> {
        try {
            if (this.token) {
                if (!options) {
                    options = {};
                }
                options.token = this.token;
            }
            const result = await this.requestService.sendXHR<TResponse>(path, data, options);
            if (typeof result === 'object' && result) {
                const token = (result as any as Nexus.Lib.Response.Part.NexusSession).nexusSessionId;
                if (token) {
                    this.setToken(token);
                }
            }
            return result;
        } catch (err) {
            if (err && typeof err === 'object' && Object.hasOwnProperty.call(err, 'error')) {
                const nexusError = err['error'] as Nexus.Api.General.ErrorResponse;
                if (nexusError?.type === 'NexusError') {
                    return {
                        error: ucfirst(nexusError.message)
                    } as any;
                }
            }
            throw err;
        }
    }

    private setToken(token: string) {
        this.localStorageService.set(storageId, token);
        this.token = token;
    }
}
